import { awaitElement, findElement } from "../utils/element-handlers.utils";

const initInstagramLinkForInstagramFeedSection = async () => {
    try {
        const instagramSectionTitle = await awaitElement('div.eui-widget-title.eapps-instagram-feed-title', 10, 1000);
        const instagramLink = findElement('a[alt="Link to Nobu Instagram page"]');

        if (instagramLink) {
            const instagramLinkForInstagramFeedSection = instagramLink.cloneNode(true) as HTMLElement;

            instagramLinkForInstagramFeedSection.style.margin = '0 0 0 16px';
            instagramLinkForInstagramFeedSection.style.top = '-5px';

            instagramSectionTitle.appendChild(instagramLinkForInstagramFeedSection);
        }
    }
    catch (error) {}
}

export default function homeHolderPage() {
    initInstagramLinkForInstagramFeedSection();
}
